import React from "react";
import { Link } from "react-router-dom";

import "./Contact.scss";
export default function Contact() {
  return (
    <div className="contact">
      {" "}
      <h1 className="contact__title">Contact Us</h1>
      <p>
        {" "}
        Thank you for your interest in contacting us today. Please see below to
        contact Steven Lim.
      </p>
      <Link
        to={{ pathname: "https://www.linkedin.com/in/steven-lim-ca/" }}
        target="_blank"
      >
        <div className="contact-linkedin-wrap">
          <div className="contact__linkedin-icon"></div>
          <p className="contact__text">Connect with me on linkedin.</p>
        </div>
      </Link>
    </div>
  );
}
